export default __webpack_public_path__ + "static/media/image.echosoft-solutions.2b5f0cd1.png";